module.exports = __webpack_public_path__ + "img/layer-device-position.8eea9b30.png";